import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Row, Col } from 'react-flexbox-grid';

import { entityType } from 'types';

import FormGroupAutoCompleteField from 'components/AutoCompleteMenuWrapper';

import '../../style.scss';

const Unmark = ({ field, matchingPatterns, isArchived, isEntityArchived }) => (
  <Row>
    <Col xs={2} styleName="field-group-type">
      Unmark
    </Col>

    <Col xs={4} data-test={`${field}-unmark-mpe`}>
      <Field
        itemWithIndex
        name={`${field}.unmark_action.matching_pattern_element`}
        placeholder="Select Entity"
        component={FormGroupAutoCompleteField}
        items={matchingPatterns}
        isDisabled={isArchived}
        isArchived={isEntityArchived}
      />
    </Col>
  </Row>
);

Unmark.propTypes = {
  field: PropTypes.string.isRequired,
  isArchived: PropTypes.bool,
  isEntityArchived: PropTypes.bool,
  matchingPatterns: PropTypes.arrayOf(entityType),
};

export default Unmark;
